export const LOGIN = "user/login";
